import { Item } from "../types/form";

// Calculate the total, subtotal, tax, and discount
export const calculateSubTotal = (items: Item[]): number => {
    let subTotal = 0;
    for (const item of items) {
      const price = parseFloat(parseFloat(item.price).toFixed(2));
      const quantity = parseFloat(item.quantity.toString());      
      if (!isNaN(price) && !isNaN(quantity)) {
        subTotal += (price * quantity);        
      }
    }
    return subTotal;
}

